import { action } from '@reatom/framework'

import { PairMigrationStatus } from '@root/entities/pair/model'
import { TradeRoute } from '@root/features/routing'
import { browserHistory } from '@root/shared/lib/react-router'

import { extractTradingPairFromRouter } from './reatom-trading-pair-address'

import type { PairModel } from '@root/entities/pair'

export const checkPairMigrationAction = action((ctx, pair: PairModel) => {
  const params = extractTradingPairFromRouter(browserHistory.location)

  if (!params) {
    return
  }

  const migrationStatus = ctx.get(pair.migrationStatus)
  if (migrationStatus instanceof PairMigrationStatus.MigratedTo) {
    browserHistory.replace(
      TradeRoute.build({
        pairAddress: migrationStatus.migration.migratedToPairAddress,
        network: pair.network,
      }),
    )
    return true
  }

  return false
}, 'checkPairMigrationAction')
